(() => {
  if (window.__naturloomGoodApiLoaded) return;
  window.__naturloomGoodApiLoaded = true;

  const endpoint = 'https://sprout-app.thegoodapi.com/app/public/budget_status?shop_name=naturloom.myshopify.com';
  const cacheKey = 'naturloom-goodapi-budget-status-v1';
  const maxAge = 15 * 60 * 1000;
  const goodApiBadgeSelector =
    "[id$='__goodapi_sprout_badge_naturloom'], [id$='__goodapi_sprout_cart_badge_naturloom']";
  const legacyProjectHost = ['earthlungs', 'reforestation.org'].join('');
  const replacementProjectUrl = 'https://www.thegoodapi.com/blog/kenya-mangroves-shopify-impact/';

  const applyState = (active) => {
    document.querySelectorAll('[data-goodapi-active]').forEach((el) => {
      el.hidden = !active;
    });
    document.querySelectorAll('[data-goodapi-fallback]').forEach((el) => {
      el.hidden = active;
    });
    document.documentElement.dataset.goodapiImpactActive = active ? 'true' : 'false';
    document.dispatchEvent(new CustomEvent('naturloom:goodapi-status', { detail: { active } }));
  };

  const validActiveState = (payload) =>
    payload && payload.budget_status === 'active' && payload.impact_setting === 'per_order';

  const readCache = () => {
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && Date.now() - cached.savedAt < maxAge) return cached.payload;
    } catch (_) {}
    return null;
  };

  const writeCache = (payload) => {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), payload }));
    } catch (_) {}
  };

  const checkStatus = async () => {
    const cached = readCache();
    if (cached) {
      applyState(validActiveState(cached));
      return;
    }
    try {
      const response = await fetch(endpoint, { method: 'GET', mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('GoodAPI status unavailable');
      const payload = await response.json();
      if (!payload || !['active', 'inactive', 'limit_reached'].includes(payload.budget_status)) {
        throw new Error('GoodAPI status malformed');
      }
      writeCache(payload);
      applyState(validActiveState(payload));
    } catch (_) {
      applyState(false);
    }
  };

  const initDialogs = () => {
    document.querySelectorAll('.nl-impact-card__open').forEach((button) => {
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const closeButton = dialog.querySelector('.nl-impact-dialog__close');
      button.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'true');
        dialog.showModal();
      });
      closeButton?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      });
    });
  };

  const initReducedMotionVideo = () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.nl-impact-hero__video').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
    });
  };

  const patchEarthLungsLinks = (scope = document) => {
    const roots = [];
    let patchedCount = 0;
    if (scope instanceof Element && scope.matches(goodApiBadgeSelector)) roots.push(scope);
    scope.querySelectorAll?.(goodApiBadgeSelector).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      root.querySelectorAll('a[href]').forEach((anchor) => {
        try {
          const url = new URL(anchor.getAttribute('href'), window.location.href);
          const normalizedHost = url.hostname.toLowerCase().replace(/^www\./, '');
          if (normalizedHost !== legacyProjectHost) return;
          anchor.href = replacementProjectUrl;
          patchedCount += 1;
          if (anchor.target === '_blank') {
            const rel = new Set(anchor.rel.split(/\s+/).filter(Boolean));
            rel.add('noopener');
            rel.add('noreferrer');
            anchor.rel = [...rel].join(' ');
          }
        } catch (_) {}
      });
    });
    return patchedCount;
  };

  const watchGoodApiLinks = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches(goodApiBadgeSelector)) roots.push(scope);
    scope.querySelectorAll?.(goodApiBadgeSelector).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (patchEarthLungsLinks(root) > 0) return;
      const observer = new MutationObserver(() => {
        if (patchEarthLungsLinks(root) > 0) observer.disconnect();
      });
      observer.observe(root, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 15000);
    });
  };

  const handleGoodApiPopupInteraction = (event) => {
    const trigger = event.target.closest('.sprout-product-modal-icon-container');
    if (!trigger || !trigger.closest(goodApiBadgeSelector)) return;
    patchEarthLungsLinks(document);
    window.requestAnimationFrame(() => patchEarthLungsLinks(document));
  };

  document.addEventListener('DOMContentLoaded', () => {
    applyState(false);
    initDialogs();
    initReducedMotionVideo();
    watchGoodApiLinks(document);
    window.setTimeout(checkStatus, 2000);
  });
  document.addEventListener('click', handleGoodApiPopupInteraction, true);
  document.addEventListener('shopify:section:load', (event) => watchGoodApiLinks(event.target));
})();
